export default __webpack_public_path__ + "static/media/episode1VideoBgM.a78d8029.jpg";